<template>
    <div class="relative">
        <flickity ref="flickity" :options="flickityOptions" @init="flickityReady">
            <slot></slot>
        </flickity>
        <div class="container mx-auto" v-if="numberOfSlide > 1">
            <div class="flex items-center justify-between pt-6 sm:pt-6 w-full">
                <button @click="previous()" class="hidden sm:inline-block btn btn-icon btn-primary xxl:absolute xxl:pin-l xxl:-ml-20 xxl:-mt-12 xxl:pin-t-1/2"><sprite sprite-id="arrow" class="fill-transparent stroke-current rotate-90 align-middle" /></button>
                <ul class="list-reset mx-auto flex">
                    <li v-for="s in numberOfSlide" :key="s" @click="select(s-1)" :class="{ 'bg-blue-dark' : s-1 == selectedIndex }" class="border border-blue-dark rounded-full bg-transparent w-4 h-4 trans mx-1 hover:bg-green hover:border-green focus:bg-green focus:border-green cursor-pointer"></li>
                </ul>
                <button @click="next()" class="hidden sm:inline-block btn btn-icon btn-primary xxl:absolute xxl:pin-r xxl:-mr-20 xxl:-mt-12 xxl:pin-t-1/2"><sprite sprite-id="arrow" class="fill-transparent stroke-current rotate-270 align-middle" /></button> 
            </div>
        </div>
        <portal to="modals" v-if="liteboxVisible">
            <vue-litebox :items="liteboxItems" :start-at="liteboxStartAt" v-on:close="hideLitebox">
                <button type="button" slot="prev" slot-scope="prevScope" v-bind="prevScope.prevProps" v-on="prevScope.prevEvents"
                    class="inline-block btn btn-icon btn-tertiary sm:ml-6">
                    <sprite sprite-id="arrow" class="fill-transparent stroke-current rotate-90 align-middle" />
                </button>
                <button type="button" slot="next" slot-scope="nextScope" v-bind="nextScope.nextProps" v-on="nextScope.nextEvents"
                    class="inline-block btn btn-icon btn-tertiary sm:mr-6">
                    <sprite sprite-id="arrow" class="fill-transparent stroke-current rotate-270 align-middle" />
                </button>
            </vue-litebox>
        </portal>
    </div>
</template>

<script>
import Flickity from './_Flickity.vue';
import VueLitebox from './_VueLitebox.vue';
import Sprite from './_Sprite.vue';
import DATON from '../vendor/DATON.js'

export default {
    name: 'Carousel',
    components:{
        Flickity,
        VueLitebox,
        Sprite
    },
    data () {
        let self = this;
        return {
            flickityOptions: {
                wrapAround: true,
                adaptiveHeight: true,
                prevNextButtons: false,
                pageDots: false,
            },
            numberOfSlide: 0,
            selectedIndex: 0,
            liteboxItems: [],
            liteboxStartAt: 0,
            liteboxVisible: false,
        }
    },
    mounted () {
        let self = this;

        let data = DATON.parse(self.$el);
        if (data.hasOwnProperty('items')){
            self.liteboxItems = data.items;
        }

        let onSelectChange = () => {
            self.selectedIndex = self.$refs.flickity.selectedIndex();
        }
        self.$refs.flickity.on('select', onSelectChange);

        let onStaticClick = (event, pointer, cellElement, cellIndex) => {
            if (event.target) {
                let lnk = event.target.closest('a[data-index]');
                let idx = parseInt(lnk.getAttribute('data-index'));
                self.liteboxStartAt = idx;
                self.liteboxVisible = true;
            }
        }
        self.$refs.flickity.on('staticClick', onStaticClick);

        self.$once('hook:beforeDestroy', () => {
            self.$refs.flickity.off('select', onSelectChange);
            self.$refs.flickity.off('staticClick', onStaticClick);
        })
    },
    methods: {
        hideLitebox() {
            this.liteboxVisible = false;
        },
        flickityReady() {
            this.numberOfSlide = this.$refs.flickity.slides().length;
        },
        next() {
            this.$refs.flickity.next();
        },
        previous() {
            this.$refs.flickity.previous();
        },
        select(s) {
            this.$refs.flickity.select(s);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/js/components/Carousel.vue